import { render, staticRenderFns } from "./ChooseSeatBackPage.vue?vue&type=template&id=05e3c27e&scoped=true"
import script from "./ChooseSeatBackPage.vue?vue&type=script&lang=js"
export * from "./ChooseSeatBackPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e3c27e",
  null
  
)

export default component.exports